import { Head, Link } from '@inertiajs/react'

export default function SignupPending() {
  return (
    <>
      <Head title="Request received - Pinnacle" />
      <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-6">
        <div className="max-w-lg w-full">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-text-primary">Pinnacle</h1>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 text-center">
            <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-[#15532E]/10 flex items-center justify-center text-[#15532E] text-2xl">✓</div>
            <h2 className="text-2xl font-bold text-text-primary">Thanks &mdash; we received your request</h2>
            <p className="mt-3 text-text-secondary text-base">
              Our team reviews new accounts daily. Once approved, your admin will receive an invitation email with a link to set their password and finish setup.
            </p>
            <p className="mt-3 text-sm text-text-muted">
              If you don&rsquo;t hear back within two business days, check your spam folder or contact support.
            </p>
            <div className="mt-6">
              <Link href="/users/sign_in" className="text-pinnacle-red hover:underline font-medium">Back to sign in</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
